import type { IMetadataRepository, MetadataSearchOptions } from '../repositories/IMetadataRepository.js';
import type { MetadataEntity } from '../entities/MetadataEntity.js';

interface Deps { metadataRepository: IMetadataRepository; }

export function createSearchMetadatasUseCase({ metadataRepository }: Deps) {
  return async function searchMetadatas(options: MetadataSearchOptions): Promise<MetadataEntity[]> {
    return metadataRepository.searchMetadatas(options);
  };
}
